<template>
  <div class="home">
    <top-box></top-box>
    <top-menu
      :selectedKeys="selectedKeys"
      :menuList="menuList"
      @set-menu="onSetMenu"
    ></top-menu>
    <div class="content-area">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import TopBox from "@/components/TopBox.vue";
import TopMenu from "@/components/TopMenu.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: { TopBox, TopMenu },
  data() {
    return {
      menuList: [],
    };
  },
  computed: {
    ...mapGetters({
      hasLogin: "hasLogin",
      isSalesHead: "isSalesHead",
      isAdmin: "isAdmin",
    }),
    selectedMenuItem() {
      const currentPath = this.$route.path;
      let selected;
      this.menuList.forEach((menuItem) => {
        if (selected) return;
        if (menuItem.children?.length) {
          menuItem.children.forEach((child) => {
            if (currentPath.startsWith(child.path)) {
              selected = child;
            }
          });
        } else {
          if (currentPath.startsWith(menuItem.path)) {
            selected = menuItem;
          }
        }
      });
      return selected;
    },
    selectedKeys() {
      if (!this.selectedMenuItem) return [];
      return [this.selectedMenuItem.routerName];
    },
  },
  methods: {
    ...mapMutations({ setPermissionList: "setPermissionList" }),
    onSetMenu(key) {
      this.$router.push({ name: key });
    },
    setMenuList() {
      const arr = [
        {
          nameTag: "l_Requests",
          routerName: "RequestsView",
          path: "/requests",
          icon: "QuestionCircleOutlined",
          children: [
            {
              label: "l_Requests",
              routerName: "RequestsRequest",
              path: "/requests",
              key: "RequestsRequest",
            },
            {
              label: "l_Archive_requests",
              routerName: "ArchiveRequests",
              path: "/requests/archive",
              key: "ArchiveRequests",
            },
          ],
        },
        {
          nameTag: "l_Orders",
          routerName: "OrdersView",
          path: "/orders/order",
          icon: "UnorderedListOutlined",
        },
        {
          nameTag: "l_Trips",
          routerName: "Trips",
          path: "/order-trip",
          icon: "CarOutlined",
        },
        {
          nameTag: "l_Clients",
          routerName: "ClientsView",
          path: "/clients",
          icon: "UserOutlined",
        },
      ];
      if (this.isSalesHead) {
        arr.push({
          nameTag: "l_Carriers",
          routerName: "CarriersView",
          path: "/carrier",
          icon: "ShopOutlined",
        });
        arr.push({
          nameTag: "l_Settings",
          routerName: "RoleList",
          icon: "SettingOutlined",
          children: [
            {
              label: "l_Classifier",
              routerName: "Classifier",
              path: "/role/classifiers",
              key: "Classifier",
            },
          ],
        });
      }
      if (this.isAdmin) {
        arr.push({
          nameTag: "l_Carriers",
          routerName: "CarriersView",
          path: "/carrier",
          icon: "ShopOutlined",
        });
        arr.push({
          nameTag: "l_Settings",
          routerName: "RoleList",
          icon: "SettingOutlined",
          children: [
            {
              label: "l_Organization",
              routerName: "Organization",
              path: "/role/organization",

              key: "Organization",
            },

            {
              label: "l_Client_to_user",
              routerName: "ClientToUser",
              path: "/client/user",

              key: "ClientToUser",
            },
            {
              label: "l_Templates",
              routerName: "TemplateList",
              path: "/role/document/templates",
              key: "TemplateList",
            },
            {
              label: "l_Classifier",
              routerName: "Classifier",
              path: "/role/classifiers",

              key: "Classifier",
            },
            {
              label: "l_Log",
              routerName: "Logs",
              path: "/role/log",
              key: "Logs",
            },
          ],
        });
      }
      this.menuList = arr;
    },
  },
  created() {
    this.setMenuList();
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;

  .content-area {
    padding: 0 15px;
    box-sizing: border-box;
  }
}
</style>
